<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="Chapter-invisible" id="_idParaDest-3"><a id="_idTextAnchor002"></a>Dedication</p>
<p class="Body-Text ParaOverride-1"><span class="CharOverride-3"><br/>
<br/>
<br/>
    To Johnisha, Susie, and Holly.</span></p>
<p class="Body-Text ParaOverride-1"><span class="CharOverride-3">I’m forever grateful for our friendship.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816115326302.vue?4dd3b874